import DialogBox from '../../../core-components/theme/components/DialogBox/DialogBox';
import { LogbookTemplateEditData } from '../types/loogBookTypes';
import LogbookTemplateModalContent from './LogbookTemplateModalContent';

interface AddLogbookTemplateModalProps {
    open: boolean;
    onClose: () => void;
    initialData?: LogbookTemplateEditData;
}

export default function AddLogbookTemplateModal({
    open,
    onClose,
    initialData,
}: AddLogbookTemplateModalProps) {
    const title = initialData?.logbookTemplateId ? 'Edit Logbook Template' : 'Add Logbook Template';

    return (
        <DialogBox open={open} onClose={onClose} title={title} width='40%' height='75vh' maxHeight='75%' maxWidth="700px">
            {open && (
              <LogbookTemplateModalContent 
                key={initialData?.logbookTemplateId || 'new'}
                onClose={onClose} 
                initialData={initialData} 
              />
            )}
        </DialogBox>
    );
}
